const editTreeComponent = () => import('./edit-tree.vue')
const singleSelectTreeComponent = () => import('./single-select-tree.vue')
const multiSelectTreeComponent = () => import('./multi-select-tree.vue')
const popSingleSelectTreeComponent = () => import('./single-tree-select.vue')
const popMultiSelectTreeComponent = () => import('./multi-tree-select.vue')
import './common.styl'

const placeTree = {
  install: function (Vue) {
    Vue.component('edit-placeTree', editTreeComponent)
    Vue.component('single-select-placeTree', singleSelectTreeComponent)
    Vue.component('multi-select-placeTree', multiSelectTreeComponent)
    Vue.component('single-placeTree-select', popSingleSelectTreeComponent)
    Vue.component('multi-placeTree-select', popMultiSelectTreeComponent)
  }
}
export default placeTree



// WEBPACK FOOTER //
// ./src/components/placeTree/index.js